export default __webpack_public_path__ + "static/media/Madiha.240488df.jpg";